module.exports = __webpack_public_path__ + "static/media/9.099f6291.jpg";